<template>
  <div class="index">
    <div class="head">
      <img src="../assets/images/index/logo.png" alt="" class="logo" />
      <img
        src="../assets/images/index/菜单栏.png"
        alt=""
        class="menu"
        @click="menu"
      />
    </div>
    <!-- <div class="menu"></div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      isShow: false,
    };
  },
  methods:{
    menu(){

    }
  }
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 99999;
 
  .head {
    display: flex;
    justify-content: space-between;
    .logo {
      //   width: 2rem;
      //   height: 0.5rem;
      width: 2.92rem;
      height: 0.82rem;
    }
    .menu {
      width: 0.55rem;
      height: 0.37rem;
      padding: 0.15rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/header.vue